var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPromptLibraryIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_9458_59506",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 47,
    height: 47,
    fill: "#000000"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 46.5,
    height: 46.5,
    fill: "#d9d9d9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_9458_59506)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.3645 39C14.3388 39 13.4578 38.6557 12.7217 37.9671C11.9854 37.2788 11.6172 36.4268 11.6172 35.4111V13.7846C11.6172 12.8726 11.9122 12.0638 12.5023 11.358C13.0922 10.6523 13.8431 10.204 14.755 10.0131L29.5305 7V31.2499L15.0081 34.2749C14.7298 34.338 14.4911 34.4735 14.292 34.6816C14.093 34.8899 13.9934 35.1331 13.9934 35.4111C13.9934 35.7625 14.1301 36.0525 14.4033 36.2812C14.6763 36.5096 14.9967 36.6238 15.3645 36.6238H33.0033V12.0693H35.3796V39H15.3645ZM18.2584 31.2044L27.1542 29.3548V9.92158L18.2584 11.7402V31.2044ZM15.8821 31.6855V12.2218L15.2425 12.3556C14.8811 12.4288 14.5825 12.5949 14.3467 12.8539C14.1112 13.1129 13.9934 13.4231 13.9934 13.7846V32.2341C14.1558 32.1506 14.3224 32.0789 14.4932 32.019C14.6638 31.9591 14.8354 31.9109 15.0081 31.8745L15.8821 31.6855Z",
    fill: "#f48536"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPromptLibraryIcon);
export default __webpack_public_path__ + "static/media/promptLibraryIcon.b23562b0291c3189665764be644a1138.svg";
export { ForwardRef as ReactComponent };